import { get, post, put } from "../api";

// Administration Lokapp : questions generales (posees a chaque location) et
// (re)generation des questions de n'importe quel outil du catalogue.

export async function getSatisfactionOverview() {
    return await get("satisfaction/admin/overview");
}

export async function getGeneralQuestions() {
    return await get("satisfaction/admin/general-questions");
}

export async function addGeneralQuestion(input) {
    return await post(input, "satisfaction/admin/general-questions");
}

export async function reorderGeneralQuestions(publicIds) {
    return await put(publicIds, "satisfaction/admin/general-questions/reorder");
}

export async function searchSatisfactionTools(type, value) {
    const params = new URLSearchParams({ type, value });
    return await get(`satisfaction/admin/tools/search?${params.toString()}`);
}

export async function getAdminToolQuestions(toolId) {
    return await get(`satisfaction/admin/tools/${toolId}`);
}

export async function generateAdminToolQuestions(toolId, ia = false) {
    return await post({}, `satisfaction/admin/tools/${toolId}/generate?ia=${ia ? "true" : "false"}`);
}

export async function generateMissingQuestions() {
    return await post({}, "satisfaction/admin/tools/generate-missing");
}

// Relance automatique (Worker) : delai avant relance des locataires sans reponse.
export async function getSatisfactionSettings() {
    return await get("satisfaction/admin/settings");
}

export async function updateSatisfactionSettings(values) {
    return await put(values, "satisfaction/admin/settings");
}

export async function sendDueRemindersNow() {
    return await post({}, "satisfaction/admin/reminders/send-now");
}
